/**
 * @desc 重新执行请求
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(
  params: API.bus.exchangeFacadeImpl.postReexecuteByRequestId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/bus/reexecuteByRequestId`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
